var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMoveRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76484 0L0.589844 1.175L4.40651 5L0.589844 8.825L1.76484 10L6.76484 5L1.76484 0Z",
    fill: "#005993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMoveRight);
export default __webpack_public_path__ + "static/media/arrow-move-right.35e853616f4ef41cdda9aa9c86e3815d.svg";
export { ForwardRef as ReactComponent };